import { CASES } from './constants';

const initialState = {
    comments: [],
    comment: {
        body: '',
        commentType: '',
        public: true,
        title: '',
    },
    commentProduct: {
        clearanceMemoTitleId: '',
        foxFinancialTitleId: '',
        productId: '',
    },
    filterForm: {
        commentType: '',
        bodyText: '',
        clearanceMemoTitleId: '',
        productId: '',
        publicPrivate: ["public", "private"],
    },
    isClearancesComment: false,
    isProductsComment: false,
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    commentRange: [0,19],
    commentSort: ["commentType", "DESC"],
    itemsPerPage: 20,
    isCommentModalOpen: false,
    isCreateModalOpen: false,
    isEditModalOpen: false,
    isAttachmentsModalOpen: false,
};

/**
 * Reducer function to manage the comments state in the Redux store.
 *
 * It handles actions related to updating comments, filtering comments,
 * and clearing comments.
 *
 * @param {Object} state - The current state of the comments.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the comments after applying the action.
 **/
export function comments(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_COMMENTS: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_COMMENTS_FILTER_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_COMMENTS: {
            return {
                ...initialState,
            };
        }
        default:
            return state;
    }
}
